import React, { useState } from "react";
import { Form, Input, Select, Button, message, Card } from "antd";
import axios from "axios";
import SummaryApi from "../common/index";

const { Option } = Select;
const { TextArea } = Input;

const RaiseQueryForm = ({ queryType }) => {
  const [loading, setLoading] = useState(false);
    const [form] = Form.useForm(); 
  const onFinish = async (values) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const payload = {
        ...values,
        query_type: queryType, // "admin_support" or "seller_support"
      };

      const response = await axios.post(
        SummaryApi.raiseUserQuery.url,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        message.success("Query raised successfully!");
        form.resetFields();
      } else {
        message.error(response.data.message || "Failed to raise query.");
      }
    } catch (error) {
      console.error(error);
      message.error(error.response?.data?.message || "Error while raising query.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      title={queryType === "admin_support" ? "Raise Query to Admin" : "Raise Query to Seller"}
      className="shadow-md rounded-lg"
      style={{ maxWidth: 600, margin: "auto", marginTop: 20 }}
    >
      <Form layout="vertical" onFinish={onFinish}>
        {/* Order Number (Mandatory) */}
        <Form.Item
          label="Order Number"
          name="order_number"
          rules={[{ required: true, message: "Please enter your order number" }]}
        >
          <Input placeholder="Enter your order number" />
        </Form.Item>

        <Form.Item
          label="Subject"
          name="subject"
          rules={[{ required: true, message: "Please enter subject" }]}
        >
          <Input placeholder="Enter subject" />
        </Form.Item>

        <Form.Item
          label="Category"
          name="category"
          rules={[{ required: true, message: "Please select category" }]}
        >
          <Select placeholder="Select category">
            <Option value="order">Order</Option>
            <Option value="product">Product</Option>
            <Option value="account">Account</Option>
            <Option value="payment">Payment</Option>
    
      
          </Select>
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please describe your issue" }]}
        >
          <TextArea rows={5} placeholder="Type your query here..." />
        </Form.Item>

        {queryType === "seller_support" && (
          <Form.Item label="Product ID (optional)" name="product_id">
            <Input placeholder="Enter related product ID" />
          </Form.Item>
        )}

        <Form.Item>
          <Button style={{background:"#1129ce",color:"white"}} htmlType="submit" loading={loading} block>
            Submit Query
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default RaiseQueryForm;
